import { sendRaw } from "../shared/sendRaw.js";
import { goalFlashSteps } from "./airSteps.js";

/** SKORE-parity GOL tape for the score `+` button: a 5 s banner run by the
 *  server; pressing again while it is on air restarts its time. */
export function useGoalFlash(slug: string) {
  const flash = (side: "home" | "away") =>
    void sendRaw("overlay.play", { slug, key: `goalflash:${side}`, steps: goalFlashSteps(side) });
  return { flash };
}
